import React, { createContext, useContext, useState } from 'react';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbContextType {
  breadcrumbs: BreadcrumbItem[];
  setBreadcrumbs: (breadcrumbs: BreadcrumbItem[]) => void;
  headerBorder: boolean;
  setHeaderBorder: (show: boolean) => void;
  headerActions: React.ReactNode | null;
  setHeaderActions: (actions: React.ReactNode | null) => void;
  rightHeaderActions: React.ReactNode | null;
  setRightHeaderActions: (actions: React.ReactNode | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextType | undefined>(undefined);

export const useBreadcrumbs = () => {
  const context = useContext(BreadcrumbContext);
  if (!context) {
    throw new Error('useBreadcrumbs must be used within a BreadcrumbProvider');
  }
  return context;
};

interface BreadcrumbProviderProps {
  children: React.ReactNode;
}

export const BreadcrumbProvider: React.FC<BreadcrumbProviderProps> = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([]);
  const [headerBorder, setHeaderBorder] = useState(true);

  const [headerActions, setHeaderActions] = useState<React.ReactNode | null>(null);
  const [rightHeaderActions, setRightHeaderActions] = useState<React.ReactNode | null>(null);

  return (
    <BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs, headerBorder, setHeaderBorder, headerActions, setHeaderActions, rightHeaderActions, setRightHeaderActions}}>
      {children}
    </BreadcrumbContext.Provider>
  );
};
